module.exports = __webpack_public_path__ + "static/media/energyeff.d10a0917.jpg";